export const rawMaterialColumns = [
  {
    dataIndex:'rawName',
    title: '原料名称'
  },
  {
    dataIndex:'rawCode',
    title: '代码'
  },
  {
    dataIndex:'percentage',
    scopedSlots: {customRender: 'percentage'},
    title: '用量(%)'
  },
  {
    dataIndex:'uasge',
    scopedSlots: {customRender: 'uasge'},
    title: '用量(批次量)'
  },
  {
    dataIndex:'unit',
    title: '单位',
    align:'center'
  },
  {
    dataIndex:'minValue',
    title: '最小值',
    // scopedSlots: {customRender: 'minValue'},
  },
  {
    dataIndex:'maxValue',
    title: '最大值',
    // scopedSlots: {customRender: 'maxValue'},
  }
]

export const nutritionColumns = [
  {
    dataIndex:'nutritionName',
    title:'指标名称'
  },
  {
    dataIndex:'nutritionFullName',
    title:'指标全称',
    width:280
  },
  // {
  //   dataIndex:'nutritionCode',
  //   title:'指标代码'
  // },
  {
    dataIndex:'content',
    scopedSlots: {customRender: 'content'},
    title:'数值',
  },
  {
    dataIndex:'unit',
    title:'单位',
    align:'center'
  },
  {
    dataIndex:'minValue',
    // scopedSlots: {customRender: 'minValue'},
    title:'最小值'
  },
  {
    dataIndex:'maxValue',
    // scopedSlots: {customRender: 'maxValue'},
    title:'最大值',
  }
]